// extracted by mini-css-extract-plugin
export default {"login":"login_login__P0KJo","logo":"login_logo__2dvtl","form":"login_form__1G6kJ"};